
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as config from '../config'
import * as history from '../history'
import * as client from '../client'
import * as feed from '../feed'
import * as storage from '../storage'
import * as exposed from '../exposed'
import * as execution from '../execution'
import * as backup from '../backup'
import * as inner from '../inner'
import * as trade from '../trade'
import * as security from '../security'
import * as document from '../document'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {ConfigUpdateRequest} from './ConfigUpdateRequest';
import {FieldModelConfigUpdateRequest} from './ConfigUpdateRequest';
import {CommissionProfileCreateResponse} from './CommissionProfileCreateResponse';
import {CommissionMode} from '../core/CommissionMode';
import {FieldModelCommissionMode} from '../core/CommissionMode';
import {CommissionChargingType} from '../core/CommissionChargingType';
import {FieldModelCommissionChargingType} from '../core/CommissionChargingType';
import {CommissionValue} from '../core/CommissionValue';
import {FieldModelCommissionValue} from '../core/CommissionValue';
import {CommissionCalculationType} from '../core/CommissionCalculationType';
import {FieldModelCommissionCalculationType} from '../core/CommissionCalculationType';
import {CommissionType} from '../core/CommissionType';
import {FieldModelCommissionType} from '../core/CommissionType';

/**
 * CommissionProfileCreateRequest struct
 */
class CommissionProfileCreateRequest extends ConfigUpdateRequest {
  /**
   * Initialize struct
   * @param {!ConfigUpdateRequest=} parent
   * @param {!string=} name
   * @param {!string=} comment
   * @param {!string=} description
   * @param {!CommissionMode=} mode
   * @param {!CommissionChargingType=} chargingType
   * @param {!Array=} values
   * @param {!CommissionCalculationType=} calculationType
   * @param {!CommissionType=} commissionType
   * @constructor
   */
  constructor (parent = new ConfigUpdateRequest(), name = '', comment = '', description = '', mode = new CommissionMode(), chargingType = new CommissionChargingType(), values = [], calculationType = new CommissionCalculationType(), commissionType = new CommissionType()) {
    super()
    super.copy(parent)
    this.Name = name
    this.Comment = comment
    this.Description = description
    this.Mode = mode
    this.ChargingType = chargingType
    this.Values = values
    this.CalculationType = calculationType
    this.CommissionType = commissionType
  }

  /**
   * Copy struct (shallow copy)
   * @this {!CommissionProfileCreateRequest}
   * @param {!CommissionProfileCreateRequest} other Other struct
   * @returns {!CommissionProfileCreateRequest} This struct
   */
  copy (other) {
    super.copy(other)
    if (other.Name != null) {
      this.Name = other.Name
    } else {
      this.Name = null
    }
    if (other.Comment != null) {
      this.Comment = other.Comment
    } else {
      this.Comment = null
    }
    if (other.Description != null) {
      this.Description = other.Description
    } else {
      this.Description = null
    }
    if (other.Mode != null) {
      this.Mode = CommissionMode.fromObject(other.Mode)
    } else {
      this.Mode = null
    }
    if (other.ChargingType != null) {
      this.ChargingType = CommissionChargingType.fromObject(other.ChargingType)
    } else {
      this.ChargingType = null
    }
    if (other.Values != null) {
      this.Values = []
      for (let item of other.Values) {
        if (item != null) {
          let tempItem
          tempItem = CommissionValue.fromObject(item)
          this.Values.push(tempItem)
        } else {
          this.Values.push(null)
        }
      }
    } else {
      this.Values = null
    }
    if (other.CalculationType != null) {
      this.CalculationType = CommissionCalculationType.fromObject(other.CalculationType)
    } else {
      this.CalculationType = null
    }
    if (other.CommissionType != null) {
      this.CommissionType = CommissionType.fromObject(other.CommissionType)
    } else {
      this.CommissionType = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!CommissionProfileCreateRequest}
   * @returns {!CommissionProfileCreateRequest} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new CommissionProfileCreateRequestModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new CommissionProfileCreateRequestModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!CommissionProfileCreateRequest}
   * @param {!CommissionProfileCreateRequest} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof CommissionProfileCreateRequest)) {
      throw new TypeError('Instance of CommissionProfileCreateRequest is required!')
    }
    // noinspection RedundantIfStatementJS
    if (!super.eq(other)) {
      return false
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!CommissionProfileCreateRequest}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    let parent = super.toJSON()
    let current = {
      Name: ((this.Name != null) ? this.Name : null),
      Comment: ((this.Comment != null) ? this.Comment : null),
      Description: ((this.Description != null) ? this.Description : null),
      Mode: ((this.Mode != null) ? this.Mode : null),
      ChargingType: ((this.ChargingType != null) ? this.ChargingType : null),
      Values: ((this.Values != null) ? Array.from(this.Values, item => ((item != null) ? item : null)) : null),
      CalculationType: ((this.CalculationType != null) ? this.CalculationType : null),
      CommissionType: ((this.CommissionType != null) ? this.CommissionType : null)
    }
    return { ...parent, ...current }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return CommissionProfileCreateRequest.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!CommissionProfileCreateRequest} other Object value
   * @returns {!CommissionProfileCreateRequest} Created struct
   */
  static fromObject (other) {
    return new CommissionProfileCreateRequest().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!CommissionProfileCreateRequest}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return CommissionProfileCreateRequest.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!CommissionProfileCreateRequest}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 6126
  }
}

export { CommissionProfileCreateRequest };

/**
 * Fast Binary Encoding CommissionProfileCreateRequest field model
 */
class FieldModelCommissionProfileCreateRequest extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this._parent = new FieldModelConfigUpdateRequest(buffer, 4 + 4)
    this.Name = new fbe.FieldModelString(buffer, this._parent.fbeOffset + this._parent.fbeBody - 4 - 4)
    this.Comment = new fbe.FieldModelString(buffer, this.Name.fbeOffset + this.Name.fbeSize)
    this.Description = new fbe.FieldModelString(buffer, this.Comment.fbeOffset + this.Comment.fbeSize)
    this.Mode = new FieldModelCommissionMode(buffer, this.Description.fbeOffset + this.Description.fbeSize)
    this.ChargingType = new FieldModelCommissionChargingType(buffer, this.Mode.fbeOffset + this.Mode.fbeSize)
    this.Values = new fbe.FieldModelVector(new FieldModelCommissionValue(buffer, this.ChargingType.fbeOffset + this.ChargingType.fbeSize), buffer, this.ChargingType.fbeOffset + this.ChargingType.fbeSize)
    this.CalculationType = new FieldModelCommissionCalculationType(buffer, this.Values.fbeOffset + this.Values.fbeSize)
    this.CommissionType = new FieldModelCommissionType(buffer, this.CalculationType.fbeOffset + this.CalculationType.fbeSize)
  }

  /**
   * Get the ConfigUpdateRequest field model
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @returns {!FieldModelConfigUpdateRequest} ConfigUpdateRequest field model
   */
  get parent () {
    return this._parent
  }

  /**
   * Get the field size
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.parent.fbeBody - 4 - 4 + this.Name.fbeSize + this.Comment.fbeSize + this.Description.fbeSize + this.Mode.fbeSize + this.ChargingType.fbeSize + this.Values.fbeSize + this.CalculationType.fbeSize + this.CommissionType.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.parent.fbeExtra + this.Name.fbeExtra + this.Comment.fbeExtra + this.Description.fbeExtra + this.Mode.fbeExtra + this.ChargingType.fbeExtra + this.Values.fbeExtra + this.CalculationType.fbeExtra + this.CommissionType.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelCommissionProfileCreateRequest.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 6126
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) > fbeStructSize) {
      return true
    }
    if (!this.parent.verifyFields(fbeStructSize)) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Name.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Name.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Name.fbeSize

    if ((fbeCurrentSize + this.Comment.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Comment.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Comment.fbeSize

    if ((fbeCurrentSize + this.Description.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Description.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Description.fbeSize

    if ((fbeCurrentSize + this.Mode.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Mode.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Mode.fbeSize

    if ((fbeCurrentSize + this.ChargingType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.ChargingType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ChargingType.fbeSize

    if ((fbeCurrentSize + this.Values.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.Values.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Values.fbeSize

    if ((fbeCurrentSize + this.CalculationType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CalculationType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CalculationType.fbeSize

    if ((fbeCurrentSize + this.CommissionType.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.CommissionType.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionType.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @param {!CommissionProfileCreateRequest} fbeValue Default value, defaults is new CommissionProfileCreateRequest()
   * @returns {!CommissionProfileCreateRequest} CommissionProfileCreateRequest value
   */
  get (fbeValue = new CommissionProfileCreateRequest()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @param {!CommissionProfileCreateRequest} fbeValue CommissionProfileCreateRequest value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.parent.fbeBody - 4 - 4) <= fbeStructSize) {
      this.parent.getFields(fbeValue, fbeStructSize)
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.parent.fbeBody - 4 - 4

    if ((fbeCurrentSize + this.Name.fbeSize) <= fbeStructSize) {
      fbeValue.Name = this.Name.get()
    } else {
      fbeValue.Name = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Name.fbeSize

    if ((fbeCurrentSize + this.Comment.fbeSize) <= fbeStructSize) {
      fbeValue.Comment = this.Comment.get()
    } else {
      fbeValue.Comment = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Comment.fbeSize

    if ((fbeCurrentSize + this.Description.fbeSize) <= fbeStructSize) {
      fbeValue.Description = this.Description.get()
    } else {
      fbeValue.Description = ''
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Description.fbeSize

    if ((fbeCurrentSize + this.Mode.fbeSize) <= fbeStructSize) {
      fbeValue.Mode = this.Mode.get()
    } else {
      fbeValue.Mode = new CommissionMode()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Mode.fbeSize

    if ((fbeCurrentSize + this.ChargingType.fbeSize) <= fbeStructSize) {
      fbeValue.ChargingType = this.ChargingType.get()
    } else {
      fbeValue.ChargingType = new CommissionChargingType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.ChargingType.fbeSize

    if ((fbeCurrentSize + this.Values.fbeSize) <= fbeStructSize) {
      this.Values.get(fbeValue.Values)
    } else {
      fbeValue.Values.length = 0
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.Values.fbeSize

    if ((fbeCurrentSize + this.CalculationType.fbeSize) <= fbeStructSize) {
      fbeValue.CalculationType = this.CalculationType.get()
    } else {
      fbeValue.CalculationType = new CommissionCalculationType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CalculationType.fbeSize

    if ((fbeCurrentSize + this.CommissionType.fbeSize) <= fbeStructSize) {
      fbeValue.CommissionType = this.CommissionType.get()
    } else {
      fbeValue.CommissionType = new CommissionType()
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.CommissionType.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @param {!CommissionProfileCreateRequest} fbeValue CommissionProfileCreateRequest value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelCommissionProfileCreateRequest}
   * @param {CommissionProfileCreateRequest} fbeValue CommissionProfileCreateRequest value
   */
  setFields (fbeValue) {
    this.parent.setFields(fbeValue)
    this.Name.set(fbeValue.Name)
    this.Comment.set(fbeValue.Comment)
    this.Description.set(fbeValue.Description)
    this.Mode.set(fbeValue.Mode)
    this.ChargingType.set(fbeValue.ChargingType)
    this.Values.set(fbeValue.Values)
    this.CalculationType.set(fbeValue.CalculationType)
    this.CommissionType.set(fbeValue.CommissionType)
  }
}

export { FieldModelCommissionProfileCreateRequest };

/**
 * Fast Binary Encoding CommissionProfileCreateRequest model
 */
class CommissionProfileCreateRequestModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelCommissionProfileCreateRequest(this.buffer, 4)
  }

  /**
   * Get the CommissionProfileCreateRequest model
   * @this {!CommissionProfileCreateRequestModel}
   * @returns {!FieldModelCommissionProfileCreateRequest} model CommissionProfileCreateRequest model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!CommissionProfileCreateRequestModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!CommissionProfileCreateRequestModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return CommissionProfileCreateRequestModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!CommissionProfileCreateRequestModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelCommissionProfileCreateRequest.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!CommissionProfileCreateRequestModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!CommissionProfileCreateRequestModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!CommissionProfileCreateRequestModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!CommissionProfileCreateRequestModel}
   * @param {!CommissionProfileCreateRequest} value CommissionProfileCreateRequest value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!CommissionProfileCreateRequestModel}
   * @param {!CommissionProfileCreateRequest} value CommissionProfileCreateRequest value, defaults is new CommissionProfileCreateRequest()
   * @return {!object} Deserialized CommissionProfileCreateRequest value and its size
   */
  deserialize (value = new CommissionProfileCreateRequest()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new CommissionProfileCreateRequest(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new CommissionProfileCreateRequest(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!CommissionProfileCreateRequestModel}
   * @param {!number} prev Previous CommissionProfileCreateRequest model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { CommissionProfileCreateRequestModel };
CommissionProfileCreateRequest.__has_response = true;
CommissionProfileCreateRequest.__response_class = CommissionProfileCreateResponse;
